import * as React from 'react';
import { Divider, Popover } from 'antd';
import '@style/component/diff/conflict-pop';
import { localizedString } from '@locale/locale';

export interface ConflictPopProps {
  icon?: JSX.Element;
  customTitle?: string | JSX.Element;
  onVisitMasterVersion?: () => void;
  onRevertMasterData?: () => void;
  onClick?: () => void;
}
export interface ConflictPopState { }
export class ConflictPop extends React.PureComponent<
  ConflictPopProps,
  ConflictPopState
> {
  render() {
    const props = this.props;

    return (
      <div
        className="private-conflict-icon"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.stopPropagation();
          e.preventDefault();

          if (props.onClick) {
            props.onClick();
          }

          return false;
        }}
      >
        <Popover
          content={(props.onRevertMasterData
            || props.onVisitMasterVersion)
            && this.popOverComp()
            || 'Compare Diffs'}
        >
          <div>
            {props.icon ? (
              props.icon
            ) : (
              <i
                style={{ color: '#FF8351' }}
                className="iconfont icon-exclamation_ic1"
              />
            )}
            {props.children}
          </div>
        </Popover>
      </div>
    );
  }

  popOverComp = () => {
    const props = this.props;

    return (
      <div className="pop-over-comp-area">
        {
          props.customTitle &&
          <div className="custom-title">
            {props.customTitle}
          </div>
        }
        {
          props.onVisitMasterVersion &&
          <div className="show-master" onClick={props.onVisitMasterVersion}>
            <span style={{ marginRight: 8 }}>{localizedString('check_on_master')}</span>
            <i className="iconfont icon-arrow_black_ic" />
          </div>
        }
        {
          (props.onVisitMasterVersion && props.onRevertMasterData || props.customTitle) &&
          <Divider style={{ marginTop: 16, marginBottom: 16 }} />
        }
        {
          props.onRevertMasterData &&
          <div className="revert-master" onClick={props.onRevertMasterData}>
            <span style={{ marginRight: 8 }}>{localizedString('revert_to_master')}</span>
            <i className="iconfont icon-withdraw_ic" />
          </div>
        }
      </div>
    );
  };
}
